import apiClient from "@/libs/axios";
import router from "@/router";
import { getMessaging, getToken } from "firebase/messaging";
import firebaseApp from "@/libs/firebase";

export const state = {
    currentUser: null,
    loggedIn: false,
    otpSent: false,
    token: null, // Add token to the state
};

export const mutations = {
    setUser(state, { user, token }) {
        state.currentUser = user;
        state.loggedIn = true;
        state.token = token; // Store the token in state
    },
    setOtpSent(state) {
        state.otpSent = true;
    },
    clearUser(state) {
        state.currentUser = null;
        state.loggedIn = false;
        state.token = null; // Clear the token on logout
    },
};

export const actions = {
    async adminLogIn({ commit, dispatch }, credentials) {
        console.log(credentials);
        await apiClient.get('sanctum/csrf-cookie'); // Ensure CSRF token for Sanctum
        let fcm_token = await dispatch('fetchFcmToken');

        await apiClient.post('/api/v1/admin-login', {...credentials, fcm_token: fcm_token})
            .then((response) => {
                console.log(response);
                // dispatch('admin/notifications/get', null, {root: true});


                dispatch('profile/profile/basic', null, {root: true});

                localStorage.setItem('user', JSON.stringify(response.data.result));

                commit('setUser', { user: response.data.result, token: response.data.result.token }); // Commit both user and token
                router.push({ name: 'dashboard' });
            })
            .catch(error => {
                throw error;
            });
    },


    async fetchUser({ commit, state }) {
        if (state.token) {
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
        }

        try {
            const response = await apiClient.get('api/v1/profile');
            commit('setUser', { user: response.data, token: state.token }); // Use existing token
        } catch {
            commit('clearUser');
        }
    },
    async logOut({ commit }) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .get('api/v1/logout')
            .then((response) => {
                console.log(response);
                commit('clearUser');
                localStorage.clear();
                sessionStorage.clear();
                // Remove the token from Axios headers on logout
                delete apiClient.defaults.headers.common['Authorization'];
                router.push({ name: 'login' });
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            });
        commit('app/loadingFinish', null, {root: true});
    },

    async fetchFcmToken() {
        // Request Notification Permission
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted.');
            } else {
                console.warn('Notification permission denied.');
            }
        });
        try {
            const messaging = getMessaging(firebaseApp);
            const vapidKey = "BAGj3fB5AgCCeQ2lcUN2Mk4lsuMXK6uG19QQHlYUgeNpk_ELvMYVuQrKinaE3ZdG_PITSsa_Lbm9TrZ4nplxGOo"; // Replace with your Firebase VAPID key

            const fcmToken = await getToken(messaging, { vapidKey });

            if (!fcmToken) {
                console.warn("FCM token not available.");
            }

            return fcmToken;
        } catch (error) {
            console.error("Error fetching FCM token:", error);
        }
    },
};

export const getters = {
    loggedIn: (state) => state.loggedIn,
    currentUser: (state) => state.currentUser,
};
